import ButtonField from "../buttonField/buttonField";
import SelectInput from "../shared/selectInput/selectInput";
import { SelectForTextFieldProps } from "./types/selectForTextFieldProps";
import './selectForTextField.scss';

const SelectForTextField = (props: SelectForTextFieldProps) => {

    return(
        <>
            <SelectInput {...props.selectInputProps} />
            <ButtonField {...props.buttonProps} />
        </>
    )
}

export default SelectForTextField;